var _rect, _rect2, _g, _path, _circle, _circle2, _path2, _path3, _g2, _circle3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorOnRegistration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 106,
    viewBox: "0 0 141 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.2834,
    y: 95.6252,
    width: 71.8579,
    height: 109.987,
    rx: 4.75627,
    transform: "rotate(-90 12.2834 95.6252)",
    stroke: "#d8ddeb",
    strokeWidth: 0.792479,
    strokeDasharray: "3.96 3.96"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5125_9663",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 32,
    width: 112,
    height: 74
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 110.779,
    y: 32.8809,
    width: 72.7558,
    height: 110.779,
    rx: 5.15251,
    transform: "rotate(90 110.779 32.8809)",
    fill: "#b3becd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5125_9663)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 105.789,
    width: 72.6504,
    height: 110.779,
    rx: 5.15251,
    transform: "rotate(-90 0 105.789)",
    fill: "#c7f0ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.871 32.605h3.62276v73.3609H106.871z",
    fill: "#82ddff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.827 44.3789C11.6927 44.3789 9.96259 46.109 9.96259 48.2433V90.3275C9.96259 92.4617 11.6927 94.1919 13.827 94.1919H42.3258C44.46 94.1919 46.1902 92.4617 46.1902 90.3275V48.2433C46.1902 46.1091 44.4601 44.3789 42.3258 44.3789H13.827zM60.6246 48C58.6551 48 57.0585 49.5966 57.0585 51.5662 57.0585 53.5357 58.6551 55.1323 60.6246 55.1323H95.4937C97.4632 55.1323 99.0599 53.5357 99.0599 51.5662 99.0599 49.5966 97.4632 48 95.4937 48H60.6246zM58.5585 60.8564C57.73 60.8564 57.0585 61.528 57.0585 62.3564 57.0585 63.1849 57.73 63.8564 58.5585 63.8564H73.5585C74.3869 63.8564 75.0585 63.1849 75.0585 62.3564 75.0585 61.528 74.3869 60.8564 73.5585 60.8564H58.5585zM57.0585 68.6963C57.0585 67.8679 57.73 67.1963 58.5585 67.1963H81.5585C82.3869 67.1963 83.0585 67.8679 83.0585 68.6963 83.0585 69.5247 82.3869 70.1963 81.5585 70.1963H58.5585C57.73 70.1963 57.0585 69.5247 57.0585 68.6963z",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 79,
    cy: 89,
    r: 5,
    fill: "#82ddff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.5213,
    cy: 89,
    r: 5,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.494 30.0005C129.121 30.0005 134.494 24.6279 134.494 18.0005 134.494 11.3731 129.121 6.00049 122.494 6.00049 115.867 6.00049 110.494 11.3731 110.494 18.0005 110.494 24.6279 115.867 30.0005 122.494 30.0005zM123.994 20.0809C123.994 20.5887 123.582 21.0004 123.074 21.0004H121.913C121.406 21.0004 120.994 20.5887 120.994 20.0809v-8.661C120.994 10.912 121.406 10.5004 121.913 10.5004H123.074C123.582 10.5004 123.994 10.912 123.994 11.4199v8.661zM123.994 24.0003C123.994 23.1719 123.322 22.5003 122.494 22.5003 121.665 22.5003 120.994 23.1719 120.994 24.0003 120.994 24.8288 121.665 25.5003 122.494 25.5003 123.322 25.5003 123.994 24.8288 123.994 24.0003z",
    fill: "#2e3545"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5125_9663",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 110,
    y: 6,
    width: 25,
    height: 25
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.494 30.0005C129.121 30.0005 134.494 24.6279 134.494 18.0005 134.494 11.3731 129.121 6.00049 122.494 6.00049 115.867 6.00049 110.494 11.3731 110.494 18.0005 110.494 24.6279 115.867 30.0005 122.494 30.0005zM123.994 20.0809C123.994 20.5887 123.582 21.0004 123.074 21.0004H121.913C121.406 21.0004 120.994 20.5887 120.994 20.0809v-8.661C120.994 10.912 121.406 10.5004 121.913 10.5004H123.074C123.582 10.5004 123.994 10.912 123.994 11.4199v8.661zM123.994 24.0003C123.994 23.1719 123.322 22.5003 122.494 22.5003 121.665 22.5003 120.994 23.1719 120.994 24.0003 120.994 24.8288 121.665 25.5003 122.494 25.5003 123.322 25.5003 123.994 24.8288 123.994 24.0003z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5125_9663)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5292,
    cy: 64.2447,
    r: 5.37507,
    fill: "#82ddff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.039 78.332C38.039 81.7733 33.7813 81.154 28.5292 81.154 23.2771 81.154 19.0195 81.7733 19.0195 78.332 19.0195 74.8908 23.2771 72.1011 28.5292 72.1011 33.7813 72.1011 38.039 74.8908 38.039 78.332z",
    fill: "#82ddff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorOnRegistration);
export default __webpack_public_path__ + "static/media/error_on_registration.168dbf5b.svg";
export { ForwardRef as ReactComponent };